import { render } from "./DamageShowComponent.vue?vue&type=template&id=08fb1d0b&scoped=true"
import script from "./DamageShowComponent.vue?vue&type=script&lang=js"
export * from "./DamageShowComponent.vue?vue&type=script&lang=js"

import "./DamageShowComponent.vue?vue&type=style&index=0&id=08fb1d0b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fb1d0b"],['__file',"resources/js/components/admin/damages/DamageShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08fb1d0b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08fb1d0b', __exports__)) {
    api.reload('08fb1d0b', __exports__)
  }
  
  module.hot.accept("./DamageShowComponent.vue?vue&type=template&id=08fb1d0b&scoped=true", () => {
    api.rerender('08fb1d0b', render)
  })

}


export default __exports__